import { render, staticRenderFns } from "./IBS-tab.vue?vue&type=template&id=8701feb0"
import script from "./IBS-tab.vue?vue&type=script&lang=js"
export * from "./IBS-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports